import { render, staticRenderFns } from "./midR.vue?vue&type=template&id=4fdd0070&scoped=true"
import script from "./midR.vue?vue&type=script&lang=js"
export * from "./midR.vue?vue&type=script&lang=js"
import style0 from "./midR.vue?vue&type=style&index=0&id=4fdd0070&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdd0070",
  null
  
)

export default component.exports